module.exports = __webpack_public_path__ + "static/media/add class.52d443a4.svg";